<template lang="pug">
  .sign-up-form
    .message-box(:class="{ alert: error.message }" v-if="error.message")
      p(v-html="multilineText")

    .title-box
      p サービスを利用するには
        br/
        | 会員登録（無料）が必要です。
    .sign-up-form-box
      text-field-with-icon(
        class="email"
        name="mail"
        placeholder="メールアドレス"
        v-model="email"
        type="email"
        autocomplete="on"
        @input="onChange"
      )
      text-field-password(
        name="password"
        placeholder="パスワード"
        v-model="password"
        :secure="!isVisiblePassword"
        @input="onChange"
        @click="onVisiblePassword"
      )
      label 半角英数字・記号を使用した8以上文字の文字列
    .tel-form-box
      text-field-with-icon(
        name="tel"
        placeholder="電話番号（任意）"
        v-model="tel"
        type="tel"
        @input="onChange"
      )
      label サポートセンターよりご連絡をする場合があります。
</template>

<style lang="scss" scoped>
.sign-up-form {
  .alert {
    background: $color-alert;
  }

  .message-box {
    width: 100%;
    min-height: 40px;
    text-align: center;

    p {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0;
      padding: 0;
      @extend %body-text;
      min-height: 40px;
      line-height: 24px;
    }
  }

  .title-box {
    width: 100%;
    height: 89px;
    text-align: center;

    p {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0;
      padding: 0;
      @extend %description;
      height: 89px;
      line-height: 24px;
    }
  }

  .sign-up-form-box {
    .email {
      margin-bottom: 16px;
    }

    label {
      display: block;
      @extend %footnote-text;
      margin: 4px 0 0 16px;
    }
  }

  .tel-form-box {
    margin-top: 42px;

    label {
      display: block;
      @extend %footnote-text;
      margin: 4px 0 0 16px;
    }
  }

  .sign-text-field {
    margin-top: 16px;
  }

  .labeled-check-box {
    text-align: right;
    margin: 24px 24px 0 0;
  }
}
</style>

<script>
import TextFieldWithIcon from '@/components/molecules/TextFieldWithIcon'
import TextFieldPassword from '@/components/molecules/TextFieldPassword'
import SubmittableForm from '@/components/mixins/SubmittableForm'
import { APPLY_CONTRACT } from '@/graphql'

export default {
  components: {
    TextFieldWithIcon,
    TextFieldPassword,
  },
  mixins: [SubmittableForm],
  props: {
    coachId: { type: String },
  },
  data() {
    return {
      email: '',
      password: '',
      tel: '',
      isVisiblePassword: true,
    }
  },
  computed: {
    multilineText: function () {
      var result = this.error.message.split('\n').map((e) => this._i18n.t(e))
      return result.join('<br>')
    },
  },
  methods: {
    async submit() {
      this.error.message = ''
      return new Promise((resolve, reject) => {
        this.applyContract(this.email, this.password, this.tel, this.coachId)
          .then(resolve)
          .catch((error) => {
            this.handleError(error)
            reject(error)
          })
      })
    },
    async applyContract(email, password, tel, coachId) {
      const variables = { email, password, tel, coachId }
      await this.$apollo.mutate(APPLY_CONTRACT(variables))
    },
    onVisiblePassword() {
      this.isVisiblePassword = !this.isVisiblePassword
    },
    validate() {
      return this.email.length > 0 && this.password.length > 0
    },
  },
}
</script>
